<template>
  <div>
    <div v-if="isTermUploadSuccessful" class="success-wrapper mw-300 mx-auto">
      <HSuccess />
      <h2 class="grey--text text-center">
        {{ $t('appointment.formCreate.titles.terminationFileUploaded') }}
      </h2>
    </div>

    <HUploading v-if="isAppointmentFilesUploading" />

    <HUpload
      @change="handleGetFiles"
      :loading="isAppointmentFilesUploading"
      fileTypes="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ref="termUploader"
      small
    />
    <p v-if="!hasTerm" class="mt-n5 caption text-center red--text">
      {{$t('rules.term')}}
    </p>
  </div>
</template>

<script>
import HUpload from '@/components/lib/HUpload'
import HSuccess from '@/components/app/HSuccess'
import HUploading from '@/components/app/HUploading'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AppointmentTermFile',

  components: {
    HUploading,
    HSuccess,
    HUpload,
  },

  computed: {
    ...mapGetters(['hasTerm', 'isTermUploadSuccessful', 'isAppointmentFilesUploading']),
  },

  methods: {
    ...mapActions(['attachTerminationFile']),

    handleGetFiles(files) {
      this.attachTerminationFile({files})
    },

    resetUploadField() {
      this.$refs.termUploader?.resetUploadField()
    }
  },
}
</script>

<style scoped>
.success-wrapper .success-animation {
  margin: 0;
  transform: scale(0.75);
}
</style>
